import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Credibility is now visual.",
    body: "Before a patient trusts your hands, they judge your feed. A quiet profile reads as a quiet practice — no matter how brilliant you are.",
  },
  {
    n: "02",
    title: "Attention is the new referral.",
    body: "Word of mouth moved to the timeline. The clinics that show up consistently are the ones that get remembered — and recommended.",
  },
  {
    n: "03",
    title: "Average marketing beats great medicine.",
    body: "It's uncomfortable, but true. The louder, clearer, more consistent voice wins the appointment. We make sure that voice is yours.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative overflow-hidden bg-obsidian py-16 md:py-20">
      <div className="noise-overlay absolute inset-0 opacity-[0.04]" />
      <div className="absolute -right-20 top-10 h-72 w-72 rounded-full bg-blue-brand/10 blur-3xl" />
      <div className="absolute -left-20 bottom-10 h-72 w-72 rounded-full bg-lab-green/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="mb-16 max-w-3xl">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-lab-green">/ The Manifesto</span>
          <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-white md:text-5xl">
            Why great practices still need great marketing.
          </h2>
        </div>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`manifesto-chapter-${c.n}`}
              className="grid grid-cols-1 gap-4 py-10 md:grid-cols-12 md:gap-8"
            >
              <div className="md:col-span-2">
                <span className="font-mono text-sm text-lab-green">Ch. {c.n}</span>
              </div>
              <h3 className="font-display text-2xl font-bold text-white md:col-span-5 md:text-3xl">{c.title}</h3>
              <p className="text-slate-400 md:col-span-5">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
